import { render, staticRenderFns } from "./bijkomende-informatie.vue?vue&type=template&id=6f73f372&scoped=true"
import script from "./bijkomende-informatie.vue?vue&type=script&lang=js"
export * from "./bijkomende-informatie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73f372",
  null
  
)

export default component.exports